// tslint:disable:no-unsafe-any (autogenerated)
/* global require, module, window */
import BaseStore from '../../components/base/base-store';
// tslint:disable-next-line:no-require-imports no-var-requires (autogenerated)
import queryString from 'query-string';

export interface ILoginStoreState {
    token: string;
    login: string;
    password: string;
    newPassword: string;
    confirmPassword: string;
    remember: boolean;
    authorizing?: boolean;
    restoringPassword?: boolean;
    restoringPasswordSuccess?: boolean;
    restoringPasswordError?: string;
    resettingPassword?: boolean;
    resettingPasswordSuccess?: boolean;
    resettingPasswordError?: string;
    validatingResetPasswordToken?: boolean;
    resetPasswordTokenValid?: boolean;
    page: string;
    authorized?: boolean;
    authorizationError?: string;
    email?: string;
    activationKey?: string;
    registration?: boolean;
    registrationSuccess?: boolean;
    registrationError?: string;
    activation?: boolean;
    activationSuccess?: boolean;
    activationError?: string;
    redirectTo?: string;
}

class LoginStore extends BaseStore<ILoginStoreState> {
    public dispatcherEvents: string = 'setLoginState';

    constructor() {
        super();
        this.initialState = LoginStore.getInitialState();
        this.initialize('LoginStore');
    }

    // tslint:disable-next-line:typedef (autogenerated)
    private static getInitialState() {
        let token = '';
        let login = '';
        let page = 'login';
        if (typeof location !== 'undefined') {
            const query = queryString.parse(location.search || '');
            if (location.pathname === '/registration') {
                page = 'registration';
            } else if (/^\/activation/i.test(location.pathname)) {
                page = 'activation';
            } else if (query.resetpasswordtoken && query.username) {
                page = 'reset-password';
                login = query.username as string;
                token = query.resetpasswordtoken as string;
            }
        }
        return {
            token,
            login,
            page,
            password: '',
            newPassword: '',
            confirmPassword: '',
            remember: true
        };
    }
}

const store = new LoginStore();
// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
